<template>
  <div>
    <c-tab
      type="horizon"
      :dense="true"
      :inlineLabel="true"
      :tabItems.sync="tabItems"
      :height="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param="popupParam"
          @deleteAssess="deleteAction"
          @insertVendorInfo="updateMode"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'vendor-assess-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmVendorEvaluationId: '',
        vendorCd: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      tab: 'vendorAssessInfo',
      tabItems: [
        { name: 'vendorAssessInfo', icon: 'edit', label: '평가정보', component: () => import(`${'./vendorAssessInfo.vue'}`) },
      ],
      addTabItems: [
        { name: 'vendorAssessHistory', icon: 'history', label: '평가이력', component: () => import(`${'./vendorAssessHistory.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  methods: {
    init() {
      if (this.popupParam.mdmVendorEvaluationId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    deleteAction() {
      this.$emit('closePopup');
    },
    updateMode(data) {
      this.popupParam.mdmVendorEvaluationId = data.mdmVendorEvaluationId;
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
  }
};
</script>
